import { Outlet, createFileRoute } from '@tanstack/react-router'

// Layout route para /dashboard/$dashboardId/sites/$siteId/blog
// Renderiza o <Outlet /> para as rotas filhas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog',
)({
  component: function BlogLayout() {
    return <Outlet />
  },
})
